import request from '@/utils/request'

export function get_qrcode(data) { // 获取二维码
  return request({
    url: '/api/v2/web/auth/random_code',
    method: 'get',
    params: data
  })
}
export function send_sms(data) { //获取验证码
  return request({
    url: '/api/v1/send_sms',
    method: 'post',
    data: data
  })
}
export function logins(data) { // web端登录
  return request({
    url: '/api/v2/web/student/login',
    method: 'post',
    data: data
  })
}
export function student_profile(data) { // 个人资料
  return request({
    url: '/api/v2/web/student/profile',
    method: 'GET',
    params: data
  })
}
export function code_status(code) { // 通过Code检查授权状态
  return request({
    url: '/api/v2/web/auth/inspect/authorization/status/'+code,
    method: 'GET',
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js